/**
 * Web stub for react-native-notifier
 */
import React, { FC, ReactNode } from 'react';

interface NotifierProps {
  [key: string]: any;
}

interface NotifierComponentsProps {
  [key: string]: any;
}

const Notifier: FC<NotifierProps> = (props) => {
  return React.createElement(React.Fragment);
};

const NotifierWrapper: FC<{ children?: ReactNode }> = ({ children }) => {
  return React.createElement(React.Fragment, {}, children);
};

// Create Alert component
const Alert = ({ title, description, alertType }: any) =>
  React.createElement(
    'div',
    {
      style: {
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: alertType === 'success' ? '#4caf50' : alertType === 'error' ? '#f44336' : '#2196f3',
        color: 'white',
        padding: '16px',
        borderRadius: '8px',
        maxWidth: '300px',
        zIndex: 10000,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      },
    },
    title && React.createElement('div', { style: { fontWeight: 'bold' } }, title),
    description && React.createElement('div', { style: { marginTop: '8px' } }, description)
  );

const NotifierComponents = {
  Alert,
  Notification: ({ title, description }: any) =>
    React.createElement(
      'div',
      {
        style: {
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: '#333',
          color: 'white',
          padding: '16px',
          borderRadius: '8px',
          maxWidth: '300px',
          zIndex: 10000,
        },
      },
      title && React.createElement('div', { style: { fontWeight: 'bold' } }, title),
      description && React.createElement('div', { style: { marginTop: '8px' } }, description)
    ),
};

// Stub notification methods
const showNotification = (config: any) => {
  console.log('Notification (web stub):', config);
};

// Stub Easing
const Easing = {
  linear: () => {},
  ease: () => {},
  quad: () => {},
  cubic: () => {},
  poly: () => {},
  sin: () => {},
  exp: () => {},
  circle: () => {},
  elastic: () => {},
  back: () => {},
  bounce: () => {},
  bezier: () => {},
  in: () => {},
  out: () => {},
  inOut: () => {},
};

export { Notifier, NotifierComponents, NotifierWrapper, showNotification, Easing };
export default Notifier;
